import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { fetchAllvehicle, vehicleSelector } from "../api/vehicles";
import { fetchAlllocation, locationSelector } from "../api/locations";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

export default function BookingForm({ id, className, buttonLabel = "Search for Cabs", initialData={} }) {
  const [formData, setFormData] = useState({
    from: "",
    to: "",
    pickupStreet: "",
    dropStreet: "",
    date: "",
    seats: "",
    //...initialData
  });
  const { all_vehicle } = useSelector(vehicleSelector);
  const { all_location } = useSelector(locationSelector);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const locations = ["Siliguri ", "Kolkata", "Gangtok", "Darjeeling"];
  const streets = ["Indiranagar", "Ullal", "Tin Factory"];
  const seatOptions = ["Economy", "Standard", "Luxury"];

  const [fromSearch, setFromSearch] = useState("");
  const [toSearch, setToSearch] = useState("");
  const [fromDropdownOpen, setFromDropdownOpen] = useState(false);
  const [toDropdownOpen, setToDropdownOpen] = useState(false)


/*useEffect(() => {
  if (all_location.length > 0 && Object.keys(initialData).length > 0) {
    setFormData(prev => ({
      ...prev,
      ...initialData
    }));
  }
}, [all_location, initialData]);*/
useEffect(() => {
 
}, [all_location, initialData, formData]);


  useEffect(() => {
    dispatch(fetchAllvehicle());
    dispatch(fetchAlllocation());
  }, [dispatch])

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (
      !formData.from ||
      !formData.to ||
      !formData.pickupStreet ||
      !formData.dropStreet ||
      !formData.date ||
      !formData.seats
    ) {
      setError("All fields are required.");
      return;
    }


    if (formData.from === formData.to) {
      setError("From and To locations cannot be the same.");
      return;
    }


    const selectedDate = new Date(formData.date);
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const tomorrow = new Date(today);
tomorrow.setDate(tomorrow.getDate() + 1);


    if (selectedDate < today) {
     setError("Date cannot be in the past.");
      return;
    }

     // New validation: max 10 days ahead allowed
  //const maxAllowedDate = new Date(today);
   //maxAllowedDate.setDate(maxAllowedDate.getDate() + 2);
    //if (selectedDate > maxAllowedDate) {
   // setError("Cannot book a cab more than 2 days prior.");
   // return;
    //}

 /*   if (
  selectedDate.getTime() === today.getTime() ||
  selectedDate.getTime() === tomorrow.getTime()
) {
  setError("You cannot book for today or tomorrow.");
  return;
}*/

    setError("");
    if (buttonLabel === "Modify") {
      navigate("/");
      return;
    }

    await localStorage.setItem('Selected Data', JSON.stringify(formData));
    navigate("/sharedcabs");

  
  };

  const today = new Date();
  const currentDate = today.toISOString().split("T")[0];



  const filteredFromLocations = all_location.filter((location) =>
    location?._id !== formData.to && // exclude selected "to"
    location?.name.toLowerCase().includes(fromSearch.toLowerCase())
  );

  const filteredToLocations = all_location.filter((location) =>
    location?._id !== formData.from && // exclude selected "from"
    location?.name.toLowerCase().includes(toSearch.toLowerCase())
  );

  return (
    <div id={id} className="max-w-4xl mx-auto px-4 font-lato mb-24" >
      <div className={`bg-white rounded-3xl shadow-lg p-8 md:p-10 -mt-24 relative z-10 ${className}`}>
        <h2 className="text-2xl md:text-3xl font-semibold text-center mb-8">
          Bookings made easy
        </h2>
        {error && (
          <p className="text-red-600 text-center mb-4 font-semibold">{error}</p>
        )}
        <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {/* Custom From Location Dropdown */}
          <div className="relative w-full">
            <div
              className="bg-gray-100 rounded-lg px-4 py-3 w-full cursor-pointer flex justify-between items-center"
              onClick={() => setFromDropdownOpen(!fromDropdownOpen)}
            >
              <span>
                {formData.from
                  ? all_location.find((loc) => loc._id === formData.from)?.name || "Select From Location"
                  : "Select From Location"}
              </span>
              <svg className="h-5 w-5 text-gray-600" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
              </svg>
            </div>
            {fromDropdownOpen && (
              <div className="absolute z-10 bg-white border border-gray-300 rounded-lg w-full mt-1 shadow-md">
                <input
                  type="text"
                  placeholder="Search..."
                  value={fromSearch}
                  onChange={(e) => setFromSearch(e.target.value)}
                  className="w-full px-4 py-2 border-b border-gray-300 focus:outline-none"
                />
                <div className="max-h-48 overflow-y-auto">
                  {filteredFromLocations.map((location) => (
                    <div
                      key={location?._id}
                      className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                      onClick={() => {
                        setFormData({ ...formData, from: location?._id });
                        setFromDropdownOpen(false);
                      }}
                    >
                      {location?.name}
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
          {/* Pickup Point Dropdown */}
          <div className="relative w-full">
          <select className="bg-gray-100 rounded-lg px-4 py-3 w-full appearance-none pr-10" value={formData.pickupStreet} onChange={(e) => setFormData({ ...formData, pickupStreet: e.target.value })}>
            <option value="">Select Pickup Point</option>
            {all_location.find((location) => location._id === formData.from)?.points?.map((street) => (
              <option key={street?.location} value={street?.location}>
                {street?.location}
              </option>
            ))}
          </select>
          <div className="pointer-events-none absolute inset-y-0 right-3 flex items-center">
             <svg className="h-5 w-5 text-gray-600" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
              </svg>
           </div>
          </div>
          {/* Date Input */}
          <DatePicker
  selected={formData.date ? new Date(formData.date) : null}
  onChange={(date) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

     const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);
    // Calculate max allowed date (today + 10 days)
   // const maxAllowedDate = new Date(today);
   // maxAllowedDate.setDate(maxAllowedDate.getDate() + 2);
   // if (date.getTime() === today.getTime() || date.getTime() === tomorrow.getTime()) {
  //    setError("You cannot book for today or tomorrow.");
   //   setFormData({ ...formData, date: "" });
     // return;
    //}
    // Clear previous error
    setError("");

    if (date < today) {
      setError("Date cannot be in the past.");
      setFormData({ ...formData, date: "" }); // Clear invalid date
      return;
    }

  //  if (date > maxAllowedDate) {
  //    setError("Cannot book a cab more than 2 days prior.");
  //    setFormData({ ...formData, date: "" }); // Clear invalid date
  //    return;
  //  }

    // If valid, set date
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    setFormData({ ...formData, date: `${year}-${month}-${day}` });
  }}
  placeholderText="Select Journey Date"
  minDate={new Date()}
 filterDate={(date) => {
  return true; // TEMP: allow all dates >= today (minDate already handles past dates)
}}
  className="bg-gray-100 rounded-lg px-4 py-3 w-full font-semibold"
  dateFormat="dd/MM/yyyy"
/> 
 {/*} <DatePicker
            selected={formData.date ? new Date(formData.date) : null}
            onChange={(date) => {
              // Convert to local date string without timezone offset
              const year = date.getFullYear();
              const month = String(date.getMonth() + 1).padStart(2, '0');
              const day = String(date.getDate()).padStart(2, '0');
              setFormData({ ...formData, date: `${year}-${month}-${day}` });
            }}
            placeholderText="Select Journey Date"
            minDate={new Date()}
            className="bg-gray-100 rounded-lg px-4 py-3 w-full font-semibold"
            dateFormat="dd/MM/yyyy"
          /> */}

          {/* Custom To Location Dropdown */}
          <div className="relative w-full">
            <div
              className="bg-gray-100 rounded-lg px-4 py-3 w-full cursor-pointer flex justify-between items-center"
              onClick={() => setToDropdownOpen(!toDropdownOpen)}
            >
              <span>
                {formData.to
                  ? all_location.find((loc) => loc._id === formData.to)?.name || "Select To Location"
                  : "Select To Location"}
              </span>
              <svg className="h-5 w-5 text-gray-600" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
              </svg>
            </div>
            {toDropdownOpen && (
              <div className="absolute z-10 bg-white border border-gray-300 rounded-lg w-full mt-1 shadow-md">
                <input
                  type="text"
                  placeholder="Search..."
                  value={toSearch}
                  onChange={(e) => setToSearch(e.target.value)}
                  className="w-full px-4 py-2 border-b border-gray-300 focus:outline-none"
                />
                <div className="max-h-48 overflow-y-auto">
                  {filteredToLocations.map((location) => (
                    <div
                      key={location?._id}
                      className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                      onClick={() => {
                        setFormData({ ...formData, to: location?._id });
                        setToDropdownOpen(false);
                      }}
                    >
                      {location?.name}
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
          {/* Drop Point Dropdown */}
          <div className="relative w-full">
          <select className="bg-gray-100 rounded-lg px-4 py-3 w-full appearance-none pr-10" value={formData.dropStreet} onChange={(e) => setFormData({ ...formData, dropStreet: e.target.value })}>
            <option value="">Select Drop Point</option>
            {all_location.find((location) => location._id === formData.to)?.points?.map((street) => (
              <option key={street?.location} value={street?.location}>
                {street?.location}
              </option>
            ))}
          </select>
           <div className="pointer-events-none absolute inset-y-0 right-3 flex items-center">
     <svg className="h-5 w-5 text-gray-600" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
              </svg>
  </div>
  </div>
          {/* Preferred Vehicle Type Dropdown */}
          <div className="relative w-full">
          <select className="bg-gray-100 rounded-lg px-4 py-3 w-full appearance-none pr-10 " value={formData.seats} onChange={(e) => setFormData({ ...formData, seats: e.target.value })}>
            <option value="">Preferred Vehicle Type</option>
            {seatOptions.map((seat) => (
              <option key={seat} value={seat}>
                {seat}
              </option>
            ))}
          </select>
           <div className="pointer-events-none absolute inset-y-0 right-3 flex items-center">
     <svg className="h-5 w-5 text-gray-600" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
              </svg>
  </div>
  </div>
          {/* Submit Button */}
          <div className="col-span-full text-center mt-4">
            <button type="submit" className="bg-gradient-to-r from-blue-300 to-blue-400 text-white rounded-lg px-6 py-3 hover:bg-[#2A1B67] transition-colors">
              {buttonLabel}
            </button>
          </div>
        </form>

        <p className="text-xl md:text-xl font-semibold text-center mt-8">
          Looking For Corporate Booking ? <Link to="/corporate-bookings"><span className="text-blue-600">Click Here</span></Link>
        </p>
      </div>

    </div>
  );
}